module.exports = __webpack_public_path__ + "img/platform.cee3f226.png";